import type { IconData } from '@stacksjs/iconify-core'

export const basicUiUpload: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m8 0l7 7h-4v4H5V7H1zm8 13v3H0v-3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiUpload
